import { SlidingDoorComponent } from '@inter-ikea-storageone/range';
import {
  addSlidingDoorFrontLayoutToFrame,
  deleteUncoupledSlidingDoors,
  isSlidingDoorLeftFrontLayout,
  isSlidingDoorRightFrontLayout
} from '@inter-ikea-storageone/range-platsa';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import {
  getFrontsOnFrame,
  getFrontsInScene,
  getMajorityDesign,
  addFrontLayoutToFrame
} from '../../shared/utils/frontLayouts';

const addFrontLayout = ({
  coreApi,
  rootState: {
    products: { inMarket: products }
  },
  props
}: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) return;

  const frontLayoutProduct = products.find(
    product => product.coreProductId === props.coreProductId
  );
  const frame = HierarchyUtils.findWithComponentInUpwardsHierarchy(
    selectedEntity,
    ComponentIds.FRAME_COMPONENT_ID
  );
  const frontPosition = coreApi.entities.getWithPosition(selectedEntity);
  if (
    !frame ||
    !frontLayoutProduct ||
    (!selectedEntity.hasComponent(ComponentIds.DOOR_COMPONENT_ID) &&
      !selectedEntity.hasComponent(ComponentIds.DRAWER_COMPONENT_ID) &&
      !selectedEntity.hasComponent(SlidingDoorComponent.id))
  ) {
    return;
  }

  if (
    isSlidingDoorLeftFrontLayout(frontLayoutProduct) ||
    isSlidingDoorRightFrontLayout(frontLayoutProduct)
  ) {
    addSlidingDoorFrontLayoutToFrame(frontLayoutProduct, frame, coreApi);
  } else {
    // Add front layout to frame where selected door/drawer sits
    const frontEntitesOnFrame = getFrontsOnFrame(frame);
    const frontEntitesInScene = getFrontsInScene(coreApi);

    const previousFrontDesign =
      frontEntitesOnFrame.length > 0
        ? getMajorityDesign(frontEntitesOnFrame)
        : getMajorityDesign(frontEntitesInScene);

    addFrontLayoutToFrame(frontLayoutProduct, frame, products, coreApi, previousFrontDesign);
    deleteUncoupledSlidingDoors(coreApi);
  }
  const entityToSelect =
    getFrontsOnFrame(frame).length > 0 && frontPosition
      ? coreApi.entities.getEntityClosestToPosition(
          { x: frontPosition.position.x, y: frontPosition.position.y },
          [ComponentIds.DOOR_COMPONENT_ID, ComponentIds.DRAWER_COMPONENT_ID]
        )
      : frame;

  if (entityToSelect) {
    coreApi.entities.select(entityToSelect);
  }
};

export default addFrontLayout;
